/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IInvisibleAnchorProps } from './invisible-anchor.props.autogenerated';

/**
 *
 * InvisibleAnchor component
 * @extends {React.PureComponent<IInvisibleAnchorProps<{}>>}
 */
class InvisibleAnchor extends React.PureComponent<IInvisibleAnchorProps<{}>> {
    public render(): JSX.Element {
        return (
            <a className='invisible-anchor' id={this.props.config.anchorId} />
        );
    }
}

export default InvisibleAnchor;
